import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconPersonDetails(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M15 8C14.4477 8 14 8.44772 14 9C14 9.55228 14.4477 10 15 10H18C18.5523 10 19 9.55228 19 9C19 8.44772 18.5523 8 18 8H15Z"
        fill="currentColor"
      />
      <path
        d="M14 12C14 11.4477 14.4477 11 15 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H15C14.4477 13 14 12.5523 14 12Z"
        fill="currentColor"
      />
      <path
        d="M15 14C14.4477 14 14 14.4477 14 15C14 15.5523 14.4477 16 15 16H18C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14H15Z"
        fill="currentColor"
      />
      <path
        d="M8 9.5C8 8.67157 8.67157 8 9.5 8C10.3284 8 11 8.67157 11 9.5C11 10.3284 10.3284 11 9.5 11C8.67157 11 8 10.3284 8 9.5Z"
        fill="currentColor"
      />
      <path
        d="M9 12C7.34315 12 6 13.3431 6 15V16H13V15C13 13.3431 11.6569 12 10 12H9Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V5ZM4 18V6H20V18H4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
